import {
  call,
  takeLatest,
  put,
  select,
} from 'redux-saga/effects';
import get from 'lodash/get';
import { message } from 'antd';
import getMetricsData from '@api/metricContainer';
import commonSelector from '@store/common/selectors';
import { selectedMetricSelector } from '@store/metricsChartContainer/selectors';
import * as commonTypes from '@store/common/types';
import * as metricsChartContainerTypes from '@store/metricsChartContainer/types';
import * as types from './types';
import selector from './selectors';
import { getDiagChartQuery, transferResponse, compareGranularity } from './helper';

function* resetSliceInterval() {
  const birdChartStore = yield select(selector);
  const {
    sliceFrom,
    sliceTo,
    lastSliceFrom,
    lastSliceTo,
    lastSliderFrom,
    lastSliderTo,
    invalidResponse,
  } = birdChartStore;

  if (
    sliceFrom
    || sliceTo
    || lastSliceFrom
    || lastSliceTo
    || lastSliderFrom
    || lastSliderTo
    || !invalidResponse
  ) {
    yield put({
      type: types.RESET_SLICE_INTERVAL,
    });
  }
}

function* fetchingToState() {
  const commonStore = yield select(commonSelector);
  const metric = yield select(selectedMetricSelector);
  const { interval } = commonStore;
  const filter = commonStore.appliedFilters[0].rule;
  if (!interval.from || !interval.to) {
    yield put({
      type: types.FETCHING_FAILS,
      errorCode: 500,
      errorMsg: 'Invalid interval',
    });
    return;
  }
  const body = getDiagChartQuery(filter, metric, interval.from, interval.to);
  try {
    const response = yield call(getMetricsData, body);
    const result = transferResponse(metric, response);
    yield put({
      type: types.FETCHING_SUCCESS,
      response: result,
    });
  } catch (error) {
    yield call(message.error, error.message);
    yield put({
      type: types.FETCHING_FAILS,
      errorCode: error.code,
      errorMsg: get(error, 'response.data.message', 'Unknown Error'),
    });
    throw error;
  }
}

function* fetchingSliceToState(action) {
  const commonStore = yield select(commonSelector);
  const birdChartStore = yield select(selector);
  const metric = yield select(selectedMetricSelector);

  const { from, to } = commonStore.interval;
  const { sliceFrom, sliceTo } = birdChartStore;
  const filter = commonStore.appliedFilters[0].rule;

  if (action.type === types.SET_SLICE_INTERVAL && !action.shouldFetch) {
    return;
  }

  if (!sliceFrom || !sliceTo || !from || !to) {
    yield put({
      type: types.FETCHING_FAILS,
      errorCode: 500,
      errorMsg: 'Invalid interval',
    });
    return;
  }
  if (sliceFrom === from && sliceTo === to) {
    return;
  }
  const compareGranularityProps = {
    sliceFrom,
    sliceTo,
    from,
    to,
  };
  if (compareGranularity(compareGranularityProps)) {
    return;
  }

  const body = getDiagChartQuery(filter, metric, sliceFrom, sliceTo);

  try {
    const response = yield call(getMetricsData, body);
    const result = transferResponse(metric, response);
    yield put({
      type: types.FETCHING_SLICE_SUCCESS,
      sliceResponse: result,
    });
  } catch (error) {
    yield call(message.error, error.message);
    yield put({
      type: types.FETCHING_SLICE_FAILS,
      errorCode: error.code,
      errorMsg: get(error, 'response.data.message', 'Unknown Error'),
    });
    throw error;
  }
}

function* watchSetSliceInterval() {
  yield takeLatest([
    commonTypes.APPLY_FILTER,
    commonTypes.INTERVAL_SELECTION,
    metricsChartContainerTypes.SELECTED_METRIC_CHART,
  ], resetSliceInterval);
}

function* watchFetchingToState() {
  yield takeLatest([
    types.FETCHING,
  ], fetchingToState);
}

function* watchFetchingSliceToState() {
  yield takeLatest([
    types.SET_SLICE_INTERVAL,
    types.FETCHING_SLICE,
  ], fetchingSliceToState);
}

export default [
  watchSetSliceInterval,
  watchFetchingToState,
  watchFetchingSliceToState,
];
